import { PaletteOptions, Theme } from '@mui/material/styles';

import { colors } from '../components/style/index';
import lightTheme from '../components/style/lightTheme';

function getPalette(theme: Theme): PaletteOptions {
  return {
    mode: 'light',
    default: {
      main: lightTheme.snackbarDefaultFill,
      light: lightTheme.snackbarDefaultFill,
      dark: lightTheme.snackbarDefaultFill,
      contrastText: lightTheme.sysPrimaryContrast,
    },
    primary: {
      main: lightTheme.sysPrimaryMain,
      light: lightTheme.sysPrimaryLight,
      dark: lightTheme.sysPrimaryDark,
      contrastText: lightTheme.sysPrimaryContrast,
    },
    secondary: {
      main: lightTheme.sysSecondaryMain,
      dark: lightTheme.sysSecondaryDark,
      light: lightTheme.sysSecondaryLight,
      contrastText: lightTheme.sysSecondaryContrast,
    },
    success: {
      main: lightTheme.sysSuccessDefault,
      dark: lightTheme.primaryBgSubtle,
      contrastText: lightTheme.sysSuccessContrast,
    },
    error: {
      main: lightTheme.sysDangerDefault,
    },
    info: {
      main: lightTheme.sysInfoDefault,
    },
    warning: {
      main: lightTheme.sysWarningDefault,
    },
    divider: lightTheme.border,
    action: {
      hover: '#0000000a',
      hoverOpacity: 0.04,
      selected: '#00000014',
      selectedOpacity: 0.08,
      disabled: '#00000061',
      disabledBackground: '#0000001f',
      disabledOpacity: 0.38,
      focus: '#0000001f',
      focusOpacity: 0.12,
      active: '#0000008f',
    },
    basePrimary: theme.palette.augmentColor({
      color: {
        main: colors.grey300,
      },
      name: 'basePrimary',
    }),
    baseBackup: theme.palette.augmentColor({
      color: {
        main: colors.grey200,
      },
      name: 'baseBackup',
    }),
    advancedPrimary: theme.palette.augmentColor({
      color: {
        main: colors.grey300,
      },
      name: 'advancedPrimary',
    }),
    advancedBackup: theme.palette.augmentColor({
      color: {
        main: colors.grey200,
      },
      name: 'advancedBackup',
    }),
    premiumPrimary: theme.palette.augmentColor({
      color: {
        main: colors.grey300,
      },
      name: 'premiumPrimary',
    }),
    premiumBackup: theme.palette.augmentColor({
      color: {
        main: colors.grey200,
      },
      name: 'premiumBackup',
    }),
    fipsPrimary: theme.palette.augmentColor({
      color: {
        main: colors.grey300,
      },
      name: 'fipsPrimary',
    }),
    fipsBackup: theme.palette.augmentColor({
      color: {
        main: colors.grey200,
      },
      name: 'fipsBackup',
    }),
    baseStandardPrimary: theme.palette.augmentColor({
      color: {
        main: colors.violet2,
      },
      name: 'baseStandardPrimary',
    }),
    baseStandardBackup: theme.palette.augmentColor({
      color: {
        main: colors.violet1,
      },
      name: 'baseStandardBackup',
    }),
    basePlusPrimary: theme.palette.augmentColor({
      color: {
        main: colors.orange3,
      },
      name: 'basePlusPrimary',
    }),
    basePlusBackup: theme.palette.augmentColor({
      color: {
        main: colors.orange1,
      },
      name: 'basePlusBackup',
    }),
    baseBioStandardPrimary: theme.palette.augmentColor({
      color: {
        main: colors.violet2,
      },
      name: 'baseBioStandardPrimary',
    }),
    baseBioStandardBackup: theme.palette.augmentColor({
      color: {
        main: colors.violet1,
      },
      name: 'baseBioStandardBackup',
    }),
    baseBioPlusPrimary: theme.palette.augmentColor({
      color: {
        main: colors.orange3,
      },
      name: 'baseBioPlusPrimary',
    }),
    baseBioPlusBackup: theme.palette.augmentColor({
      color: {
        main: colors.orange1,
      },
      name: 'baseBioPlusBackup',
    }),
    advancedStandardPrimary: theme.palette.augmentColor({
      color: {
        main: colors.blue2,
      },
      name: 'advancedStandardPrimary',
    }),
    advancedStandardBackup: theme.palette.augmentColor({
      color: {
        main: colors.blue1,
      },
      name: 'advancedStandardBackup',
    }),
    advancedPlusPrimary: theme.palette.augmentColor({
      color: {
        main: colors.teal100,
      },
      name: 'advancedPlusPrimary',
    }),
    advancedPlusBackup: theme.palette.augmentColor({
      color: {
        main: colors.teal50,
      },
      name: 'advancedPlusBackup',
    }),
    advancedBioStandardPrimary: theme.palette.augmentColor({
      color: {
        main: colors.blue2,
      },
      name: 'advancedBioStandardPrimary',
    }),
    advancedBioStandardBackup: theme.palette.augmentColor({
      color: {
        main: colors.blue1,
      },
      name: 'advancedBioStandardBackup',
    }),
    advancedBioPlusPrimary: theme.palette.augmentColor({
      color: {
        main: colors.teal100,
      },
      name: 'advancedBioPlusPrimary',
    }),
    advancedBioPlusBackup: theme.palette.augmentColor({
      color: {
        main: colors.teal50,
      },
      name: 'advancedBioPlusBackup',
    }),
    complianceStandardPrimary: theme.palette.augmentColor({
      color: {
        main: colors.indigo3,
      },
      name: 'complianceStandardPrimary',
    }),
    complianceStandardBackup: theme.palette.augmentColor({
      color: {
        main: colors.indigo1,
      },
      name: 'complianceStandardBackup',
    }),
    compliancePlusPrimary: theme.palette.augmentColor({
      color: {
        main: colors.yellow2,
      },
      name: 'compliancePlusPrimary',
    }),
    compliancePlusBackup: theme.palette.augmentColor({
      color: {
        main: colors.yellow1,
      },
      name: 'compliancePlusBackup',
    }),
    disabled: theme.palette.augmentColor({
      color: {
        main: lightTheme.icon,
      },
      name: 'disabled',
    }),
  };
}

export default getPalette;
